<template>
  <v-container>
    <v-row>
      <v-col>
        <span class="title">
          {{ $t("memberView.welcome", { username: currentUser.username }) }}
        </span>
      </v-col>
    </v-row>
    <v-row class="mb-2">
      <v-col>
        <v-btn
          color="primary"
          href="https://onlinelibrary.wiley.com"
          target="_blank"
        >
          <v-icon small left>mdi-library</v-icon>
          {{ $t("memberView.wiley") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-divider />
    <v-row>
      <v-col>
        <span class="title">
          {{
            $t("memberView.membership", {
              memberType: $t(`memberType.${currentUser.attributes.memberType}`),
            })
          }}
        </span>
        <div class="subtitle-1">
          {{
            $t("memberView.membershipYear", {
              year: joinYear,
            })
          }}
        </div>
        <v-list class="ml-n4">
          <v-list-item v-for="payment in openPayments" :key="payment.year">
            <v-list-item-content>
              <v-list-item-title
                v-html="
                  $t('memberView.membershipFee', {
                    year: payment.year,
                    amount: payment.fee,
                  })
                "
              />
              <v-list-item-subtitle
                :class="`${payment.paid ? 'green' : 'red'}--text`"
                v-html="$t(`paymentState.${payment.paid ? 'paid' : 'notPaid'}`)"
              />
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row class="mt-n4 mb-2" v-if="feeToPay > 0">
      <v-col>
        <v-btn color="primary" to="/membership/payment">
          <v-icon small left>mdi-wallet</v-icon>
          {{ $t("memberView.pay", { amount: feeToPay }) }}
        </v-btn>
      </v-col>
    </v-row>
    <v-divider v-if="events.length > 0" />
    <v-row v-if="events.length > 0">
      <v-col>
        <span class="title">
          {{ $t("memberView.events") }}
        </span>
        <v-list class="ml-n3" two-line>
          <v-list-item v-for="event in events" :key="event.title">
            <v-list-item-content>
              <v-list-item-title v-text="event.title"></v-list-item-title>
              <v-list-item-subtitle>
                ({{ event.dateFrom | formatDate }} -
                {{ event.dateTo | formatDate }})
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="event.register && event.registerUrl">
              <v-btn
                color="primary"
                :href="getRegisterUrl(event.registerUrl)"
                target="_blank"
              >
                <v-icon small left>mdi-login</v-icon>
                {{ $t("memberView.register") }}
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import * as moment from "moment";
import { openPaymentsResource } from "../api/resources";

export default {
  data: () => ({
    openPayments: [],
  }),
  mounted() {
    this.loadPaymentState();
  },
  computed: {
    ...mapGetters(["currentUser", "pageSettings"]),
    events() {
      if (!this.pageSettings || !this.pageSettings.memberEvents) {
        return [];
      }
      return this.pageSettings.memberEvents.filter((event) =>
        moment(event.dateTo).isAfter(moment())
      );
    },
    currentYear() {
      return moment().year();
    },
    currentFee() {
      if (!this.pageSettings) {
        return null;
      }
      return this.pageSettings[
        `price${this.currentUser.attributes.memberType}`
      ];
    },
    paymentState() {
      return (
        this.currentUser.attributes[`paymentState-${moment().year()}`] ||
        "notPaid"
      );
    },
    joinYear() {
      if (this.currentUser.attributes.entryDate) {
        return this.currentUser.attributes.entryDate.substring(0, 4);
      }
      return moment(this.currentUser.createdTimestamp).format("YYYY");
    },
    feeToPay() {
      const filteredPayments = this.openPayments.filter((entry) => !entry.paid);
      return filteredPayments.length > 0
        ? filteredPayments
            .map((entry) => entry.fee)
            .reduce((entry1, entry2) => entry1 + entry2)
        : 0;
    },
  },
  methods: {
    getRegisterUrl(url) {
      const urlObject = new URL(url);
      return `${urlObject.origin}/sso/login?redirectUrl=${url}`;
    },
    async loadPaymentState() {
      this.openPayments = (await openPaymentsResource.get()).data;
    },
  },
};
</script>
